












import { Component, Prop, Vue } from "vue-property-decorator";
import { SecurityService } from "@/services/SecurityService";
import SessionClosedViewModel from "@/models/security/zorgID/sessionClosedViewModel";
import CloseSessionComponent from "@/components/zorgID/CloseSessionComponent.vue";

@Component({
  components: {
    CloseSessionComponent,
  },
})
export default class Logout extends Vue {
  public $refs!: Vue["$refs"] & {
    closeSessionComponent: CloseSessionComponent;
  };

  private btnLogoutEnabled: boolean = SecurityService.getInstance().isLoggedOn();

  private logout() {
    var me = this;
    this.btnLogoutEnabled = false;
    this.$refs.closeSessionComponent.logout();
  }
}
